import React from 'react';

class Map extends React.Component {
	componentDidMount() {
		this.createMap();
	}

	createMap = async () => {
		try {
			const mapboxgl = await import('mapbox-gl');
			mapboxgl.accessToken = 'pk.eyJ1IjoiaGFmZmZlIiwiYSI6ImNqa2lyNXg4OTAyN3Uzd3RqNmV5eTVtZ3cifQ.knrxh-50jffUJ1lk3cy3Tg';

			this.map = new mapboxgl.Map({
				container: this.mapContainer,
				style: 'mapbox://styles/mapbox/light-v8',
				center: [13.4443479, 57.8030011],
				zoom: 12,
				interactive: false
			});

			this.createMarker(mapboxgl, this.map, [13.4443479, 57.8030011]);
		} catch (error) {
			console.error('mapbox error', error);
		}
	}

	getContainer = el => {
		this.mapContainer = el;
	}

	getMarker = el => {
		this.mapMarker = el;
	}

	createMarker = (mapbox, map, coordinates) => {
		const el = document.createElement('div');
		el.className = 'Map-marker';
		el.innerHTML = '<img className=\'Map-icon\' src=\'/static/marker.png\'/>';
		el.style.width = '40px';
		el.style.height = '40px';
		new mapbox.Marker(el, {offset: [15, 0]}).setLngLat(coordinates).addTo(map);
	}

	render() {
		return (
			<div ref={this.getContainer} className='Map-container'>
				<style jsx>
					{`
						.Map-container {
							width: 100%;
							height: 400px;
							margin-bottom: 20px;
						}

						.mapboxgl-control-container {
							display: none;
						}
					`}
				</style>
			</div>
		);
	}
}

export default Map;



// WEBPACK FOOTER //
// components/map.js